import { faHistory } from '@fortawesome/pro-regular-svg-icons'

import { useTranslation } from '@flecto/translations'
import { type CoreInquiry } from '@flecto/types'
import { Modal } from '@flecto/ui'

import { useInquiryActions } from '../../hooks/useInquiryActions'

export type ModalReopenInquiryProps = {
  inquiry?: CoreInquiry
}

export function ModalReopenInquiry({ inquiry }: ModalReopenInquiryProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'inquiries' })

  const { handleUnapprove } = useInquiryActions({ inquiry })

  return <Modal>
    <Modal.Icon icon={faHistory} />
    <Modal.Title>{t('modal.reopen_title')}</Modal.Title>
    <Modal.Subtitle>
      {t('modal.reopen_description')}
    </Modal.Subtitle>
    <Modal.Cancel />
    <Modal.Submit onClick={() => handleUnapprove()}>
      {t('label_confirm')}
    </Modal.Submit>
  </Modal>
}
